
import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { OxygenControlsTreeContext } from "@/oxygen/classes/lib/types";
import { configStore, globalStore } from "@/store/store";
import { getFullSelectorName } from "@/oxygen/classes/lib/utils";
import {
  DEVICE_ICONS,
  customBreakpointIcon
} from "@/lib/breakpoints/breakpoints";
import OxyClassToken from "./OxyClassToken.vue";
import Icon from "@/components/UI/Icon.vue";
import { isGlobalVariable } from "@/oxygen/variables/lib/utils";
import {
  isValueInheritted,
  isValueOverwritten,
  isValueFromBreakpoint
} from "@/oxygen/classes/lib/inheritance";
import OxygenDisplayValue from "./OxygenDisplayValue.vue";

@Component({
  components: {
    Icon,
    OxyClassToken,
    OxygenDisplayValue
  }
})
export default class OxygenControlName extends Vue {
  @Prop({ default: false })
  filled!: boolean;

  @Inject({ from: "oxyContext", default: null })
  readonly context!: OxygenControlsTreeContext;

  @Prop()
  path!: string;

  @Prop({ default: true })
  applyFillClass!: boolean;

  get inheritance() {
    return this.context?.getControlInheritance(this.path);
  }

  get isInheriting() {
    return isValueInheritted(this.inheritance);
  }

  get isOverwritten() {
    return isValueOverwritten(this.inheritance);
  }

  get selectorLabel() {
    const selector = globalStore.oxySelectors.find(
      s => s.id === this.inheritance?.from
    );

    if (!selector) return null;

    return getFullSelectorName(selector);
  }

  get breakpoint() {
    return this.inheritance?.breakpoint;
  }

  get breakpointLabel() {
    const breakpoint = configStore.breakpoints.find(
      b => b.id === this.breakpoint
    );
    return breakpoint?.label || "Unknown breakpoint";
  }

  get deviceIcon() {
    if (!this.breakpoint) return null;
    return DEVICE_ICONS[this.breakpoint]?.icon || customBreakpointIcon;
  }

  get deviceIconRotation() {
    if (!this.breakpoint) return 0;
    return DEVICE_ICONS[this.breakpoint]?.rotate;
  }

  get isGlobalVariable() {
    if (this.isInheriting) return false;
    return isGlobalVariable(this.inheritance?.value);
  }

  get isFromBreakpoint() {
    return isValueFromBreakpoint(this.inheritance);
  }

  get showTooltip() {
    return (this.isOverwritten || this.isInheriting) && this.inheritance;
  }
}
